export default __webpack_public_path__ + "static/media/submenu-robot-H1.6a00ff63.png";